import { z } from "zod";
import { DisciplinaItemChecklistSchema } from "./disciplina_item_checklist";

export const DisciplinaChecklistSchema = z.object({
  idDisciplinaChecklist: z.number().nullable().optional(),
  idChecklist: z.number().nullable().optional(),
  idFuncionarioValidacao: z.number().nullable().optional(),
  dataValidacao: z.date().nullable().optional(),
  idFuncionarioVerificacao: z.number().nullable().optional(),
  dataVerificacao: z.coerce.date().nullable().optional(),
  outrosItens: z.string().nullable().optional(),
  normasTecnicas: z.string().nullable().optional(),
  observacoes: z.string().nullable().optional(),
  arquivo1: z.any().nullable().optional(),
  nomearquivo1: z.string().nullable().optional(), 
  limparArquivo1: z.boolean().default(false),

  status: z.coerce.number().nullable().optional(),

  itens: z.array(DisciplinaItemChecklistSchema).optional(),
});

export type DisciplinaChecklistForm = z.infer<typeof DisciplinaChecklistSchema>;


